<div class="row">
  <div class="container p-4 p-md-5 col">
    <div class="d-flex justify-content-end">
      <app-button id="back-desktop" [onlyIcon]="true" [isIcon]="true" 
        [left]="true" [iconName]="'bi bi-arrow-left'"
        [buttonOptions]="buttonOptions" (buttonClick)="back()">
      </app-button>
    </div>
    <div class="manage-payment-main-title my-4" [style.color]="labelColor">
      Gerenciar Pagamento
    </div>
    <div *ngIf="creditCardInfo; else noCardTemplate">
      <div class="card my-4 p-1 px-2">
        <div class="d-flex align-items-center">
          <!-- Ícone do cartão -->
          <mat-icon class="p-1 me-2 mat-icon-credit" svgIcon="{{creditCardInfo.cardBrand}}"
            *ngIf="creditCardInfo.cardBrand && !creditCardInfo.isOutdated">
          </mat-icon>
          <mat-icon class="p-1 me-2 mat-icon-credit"
            *ngIf="!creditCardInfo.cardBrand || creditCardInfo.isOutdated">
            credit_card
          </mat-icon>
          <mat-icon class="p-1 me-2 mat-icon-credit"
            *ngIf="creditCardInfo.cardBrand === 'credit_card'">
            credit_card
          </mat-icon>

          <div class="w-100 m-2">
            <div class="d-grid credit-card-info-md">
              <span class="p-1 card-operator">
                {{
                  creditCardInfo.isOutdated 
                    ? 'Cartão desatualizado' 
                    : creditCardInfo.cardBrand === 'credit_card' || creditCardInfo.cardBrand === 'card_credit' 
                      ? 'Cartão de Crédito' 
                      : (creditCardInfo.cardBrand | titlecase)
                }}
              </span>
              <span class="p-1 card-number" *ngIf="!creditCardInfo.isOutdated && creditCardInfo.lastCardDigits">
                .... .... .... {{creditCardInfo.lastCardDigits}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #noCardTemplate>
      <div class="text-center my-4">
        Você ainda não possui um cartão adicionado.
      </div>
    </ng-template>
    <div class="mt-5 mb-3 text-center">
      <app-button [buttonOptions]="buttonAddCardOptions" routerLink="/adicionar-cartao"></app-button>
    </div>
  </div>
</div>